import ReactPaginate from "react-paginate";
import styled, { css } from "styled-components";
import { getThemeFontWeight, getThemeSpace } from "../helpers";
export const PaginationContainer = styled(ReactPaginate) `
	display: flex;
	gap: ${getThemeSpace("8")};
	list-style: none;

	*::selection {
		background-color: transparent;
	}

	& > li {
		cursor: pointer;

		border-radius: 8px;

		color: var(--surface-accent);
		font-weight: ${getThemeFontWeight("bold")};

		transition: all 130ms ease-in-out;

		&.selected,
		&:hover {
			background-color: var(--surface-accent);

			color: var(--text-invert);
		}

		&:hover {
			box-shadow: 0px 1.8px var(--surface-accent-dark);
		}

		& > a {
			display: flex;
			align-items: center;
			justify-content: center;

			color: inherit;

			width: 32px;
			height: 32px;
		}

		&.break {
			background-color: transparent;

			box-shadow: none;

			color: var(--surface-accent);
			pointer-events: none;
		}

		&.previous,
		&.next {
			background-color: transparent;

			box-shadow: none;
		}
	}

	${({ disabled }) => disabled &&
    css `
			& > li {
				background-color: transparent;

				color: var(--text-primary);
				pointer-events: none;

				&.selected {
					background-color: var(--surface-primary);

					color: inherit;
				}
			}
		`}

	${({ waiting }) => waiting &&
    css `
			* {
				cursor: wait;
			}
		`}
`;
//# sourceMappingURL=styles.js.map